module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABUklEQVRIie2XvUrEQBSFv7sGK8WfQtutLLSyE3S1UYTV3ReZ58mLuK6Ngt1WCoJPoKDYaaOgzbXIZEl2zWRifqocSDHMzXxnEph7RmhAYrQD7AI94BDoSY2wZeAYGAJ9YCM1XzGsCwzscwQsZtaWBC0AewnYtqP8J2mkMFiMrgCnFtQH1h3lL8AVMALugNd4IhCjqx68TQsZAgdAkFGnFjAGLoAHDUWt4RQnAN49wC59AjdEuxprKG8+L2U5z9MT0a5GwK2G8l10gSLgSQzTUB6LgvLAazPj6W/QUPbLwjLBGspHcixGq2Sl1Klt5RbcgltwC65LqSNTjGaekWJ0AlxSUZMQF8yh59gEnm3RBoFp0/kvOKkv4JqcIDAH9llZjG4BZ/hFn3uir/FX9CkGnjFRSdirMt6eAzuO8nLxNsdIlyYCfY6JJeCEJq4wDhNzl7ZfhC1szuymeOkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yunying.png
// module id = UaAs
// module chunks = 1